<template>
	<div>
		<div class="imagecontainer" style="padding-top: 20px;">
			<img src="../assets/iread.png" style="width: 440px;height: 159px;"/>
		</div>
		<div class="imagecontainerone" style="padding-top: 0px;">
			<img src="../assets/come.png" style=" width: 950px;height: 36px;"/>
		</div>
		
		<div class="imagecontainerone">
			<div style="margin-top: 149px;display: flex;">
				<div>
					<img src="../assets/companyleft.png" style=" width: 261px;height: 80px;"/>
					<div class="culture">CULTURE</div>
					<div class="resonat">
						At IREAD,we bring global storis to life——inviting you into a world of romance,drama,and adventure, where every reader discovers a tale that truly resonat.
					</div>
				</div>
				<div style="padding-left: 331px;">
					<img src="../assets/companyright.png" style=" width: 637px;height: 203px;"/>
				</div>
			</div>
		</div>
		
		<div class="imagecontainerone">
			<div style="margin-top: 149px;display: flex;">
				<div>
					<img src="../assets/companyrightone.png" style=" width: 637px;height: 203px;"/>
				</div>
				
				<div>
					<img src="../assets/companyleft.png" style="width: 343px;height: 80px;padding-left: 331px;"/>
					<div class="technology">TECHNOLOGY</div>
					<div class="platform">
						Our platform makes reading effortless and enjoyable.With tailored recommendations and a seamless reading experience,the perfect book is always within reach.
					</div>
				</div>
			</div>
		</div>
		
		<div class="imagecontainerone" style="padding-top: 114px;">
			<div class="businessBG">
				<div class="businesstext">BUSINESS DEVELOPMENT</div>
			</div>
		</div>
		
		<div class="imagecontainerone" style="padding-top: 60px;">
			<div class="line">
				<img src="../assets/companyone.png" class="lineimg"/>
			</div>
			<div class="line">
				<img src="../assets/companytwo.png" class="lineimg"/>
			</div>
			<div class="line">
				<img src="../assets/companythree.png" class="lineimg"/>
			</div>
			<div class="line">
				<img src="../assets/companyfour.png" class="lineimg"/>
			</div>
			<div class="line">
				<img src="../assets/companyfive.png" class="lineimg"/>	
			</div>
		</div>
		<div class="imagecontainerone" style="padding-top: 60px;">
			<img src="../assets/companyus.png" class="companyus"/>
		</div>
		
		<div class="imagecontainerone" style="margin-top: -70px;">
			<div class="invite">
				<div style="padding-top: 84px;">
					<img src="../assets/invite.png" style="width: 841px;height: 31px;"/>
				</div>
				
				<div class="search" >
					<el-input placeholder="" v-model="email" class="input-with-select">
					    <el-button slot="append" icon="" class="btn" @click="submit()">Submit</el-button>
					</el-input>
				</div>
				
				<nav class="navbar">
				      <ul class="nav-list" >
				        <li class="nav-item" v-for="(item,index) in tabsList" :key="index">
							<img src="../assets/Group.png" style="width: 166px;height: 48px;"/>
							<div class="about">{{item.name}}</div>
							<div v-show="index==0" class="content" @click="Jump('HelloNovel')">HelloNovel</div>
							<div v-show="index==0" style="margin-top: 10px;" class="content" @click="Jump('Company')">Company</div>
							<div v-show="index==0" style="margin-top: 10px;" class="content">Privacy policy</div>
							<div v-show="index==0" style="margin-top: 10px;" class="content">Terms of service</div>
							<div v-show="index==1" class="content" @click="Jump('Author Recruitment')">Author Recruitment</div>
							<div v-show="index==2" class="content" @click="Jump('Contact Information')">Contact Information</div>
						</li>
						
				      </ul>
				</nav>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data(){
			return{
				email:'',
				tabsList:[{name:'About us'},{name:'Join us'},{name:'Contact us'},{name:'Stay tuned...'}]
			}
		},
		
		methods:{
			submit(){
				this.$message('success');
			},
			Jump(val){
				this.$emit('message-from-child', val);
			}
		}
	}
</script>

<style scoped="scoped">
	
	/deep/.el-input__inner{
		border: 3px solid #FF973C !important;
		border-radius: 13px;
		height: 51px;
		line-height: 51px;
	}
	
	/deep/.el-input-group__append{
		border-radius: 13px;
		border: 3px solid #FF973C;
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
		border-left: 0;
		background-color: #FF973C;
		font-weight: 900;
		font-size: 22px;
		color: #FFFFFF;
	}
	
	
	.imagecontainer {
	  display: flex;
	  justify-content: center;
	  padding-top: 20px;
	  
	}
	
	.imagecontainerone {
	  display: flex;
	  justify-content: center;
	  padding-top: 20px;
	}
	
	.culture{
		margin-top: -72px;
		font-family: Inter, Inter;
		font-weight: 900;
		font-size: 30px;
		color: #FEFCFA;
	}
	
	.resonat{
		width: 515px;
		height: 101px;
		text-align: left;
		padding-top: 60px;
		position: absolute;
		padding-left: 20px;
		font-family: Inter, Inter;
		font-weight: 500;
		font-size: 20px;
		color: #304800;
	}
	
	.technology{
		margin-top: -72px;
		font-family: Inter, Inter;
		font-weight: 900;
		font-size: 30px;
		color: #FEFCFA;
		padding-left: 331px;
	}
	
	.platform{
		width: 555px;
		height: 101px;
		text-align: right;
		padding-top: 50px;
		position: absolute;
		padding-left: 120px;
		font-family: Inter, Inter;
		font-weight: 500;
		font-size: 20px;
		color: #304800;
	}
	
	.businessBG{
		width: 572px;
		height: 25px;
		background: #B4CCED;
		border-radius: 0px 0px 0px 0px;
		opacity: 0.7;
	}
	
	.businesstext{
		font-family: Inter, Inter;
		font-weight: 900;
		font-size: 36px;
		color: #FF8215;
	}
	
	.line{
		padding-right: 50px;
		padding-bottom: 50px;
	}
	
	.lineimg{
		width: 208px;
		height: 343px;
	}
	
	.companyus{
		width: 377px;
		height: 95px;
		position: relative;
		z-index: 999;
	}
	
	.invite{
		width: 1224px;
		height: 502px;
		/* background: #FFFFFF; */
		border-radius: 21px;
		/* opacity: 0.69; */
		margin-bottom: 90px;
		background: #F9FCF4;
	}
	
	.search{
		display: flex;
		justify-content: center;
		position: relative;
		z-index: 999;
	}
	
	.input-with-select{
		margin-top: 62px;
		width: 680px !important;
	}
	
	.btn{
		/* background-color:#FF973C !important; */
		font-family: Inter, Inter;
		font-weight: 900;
		font-size: 22px;
		height: 51px;
		color: #FFFFFF !important;
	}
	
	.navbar {
	  overflow: hidden;
	  padding-top: 58px;
	  /* position: absolute;
	  bottom: 0;
	  left: 0;
	  right: 0;
	  margin: auto;
	  width: 100%; */
	  /* padding-bottom: 150px; */
	}
	
	.nav-list {
	  list-style-type: none; 
	  margin: 0;
	  padding: 0;
	  display: flex;
	  justify-content: center;
	}
	
	.nav-item {
	  float: left; 
	  padding: 20px 30px;
	}
	
	.about{
		margin-top: -38px;
		font-family: Inter, Inter;
		font-weight: bold;
		font-size: 19px;
		color: #FFFFFF;
	}
	
	.content{
		margin-top: 20px;
		font-family: Inter, Inter;
		font-weight: normal;
		font-size: 13px;
		color: #606060;
	}
	
</style>